import axios from "../axiosInstance";

const mpSportAPI = {
  store: (payload) => axios.post("admin/mp-sport/store", payload),
  storeSelection: (payload) => axios.post("admin/mp-sport/storeSelection", payload),
};

export default mpSportAPI;
